import { useState } from "react";
import { LogOut, ChevronDown, UserCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

function TopNavbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const name = user.fullName || user.username;

  return (
    <header className="h-[72px] bg-white border-b border-gray-200 px-6 lg:px-8 flex items-center justify-between">
      <div>
        <p className="text-xs uppercase tracking-wider text-gray-400">Lightspeed Photonics</p>
        <p className="text-sm font-medium text-[#111111]">Employee Portal</p>
      </div>

      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-3 pl-3 pr-2 py-1.5 rounded-lg hover:bg-gray-50 border border-transparent hover:border-gray-200"
        >
          <div className="text-right">
            <p className="text-sm font-medium text-[#111111] leading-tight">{name}</p>
            <p className="text-xs text-gray-500 leading-tight capitalize">
              {user.role === "admin" ? "Administrator" : user.designation || "Employee"}
            </p>
          </div>
          <div className="w-9 h-9 rounded-full bg-[#C00000] text-white flex items-center justify-center text-sm font-semibold">
            {name.charAt(0).toUpperCase()}
          </div>
          <ChevronDown size={14} className="text-gray-400" />
        </button>

        {open && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
            <div className="absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-xl shadow-lg z-20 py-1.5">
              <button
                onClick={() => { setOpen(false); navigate("/dashboard/profile"); }}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
              >
                <UserCircle2 size={16} /> My Account
              </button>
              <button
                onClick={logout}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm text-[#8B0000] hover:bg-red-50"
              >
                <LogOut size={16} /> Sign out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}

export default TopNavbar;
